import { DataBean } from "../DataBean";

export class SocialSecuritySpreadSheetExp extends DataBean {


    public async exportSocialSecuritySpreadSheet(idSocialSecurityTemplate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportSocialSecuritySpreadSheet_Number", [idSocialSecurityTemplate]);
    }

}